/**
 * Created by Roman on 10.12.2025
 */

const LightningRushTutorial = function () {
    return new TutorialScenario(LightningRushTutorial.NAME, {
        listSteps: LightningRushTutorial.listSteps,
        onStart: function () {},
        onFinish: function () {},

        isAvailable: function () {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LIGHTNING_RUSH);

            if (!mission) {
                return;
            }

            return !cleverapps.forces.isShown(Forces.LIGHTNING_RUSH) && mission.logic.isActiveState();
        }
    });
};

LightningRushTutorial.listSteps = function () {
    return [
        LightningRushTutorial.createWindowStep(),
        LightningRushTutorial.createWindowPopAction(),
        LightningRushTutorial.createGuideStep()
    ];
};

LightningRushTutorial.createWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LIGHTNING_RUSH);

            const WindowCtor = mission.getViewClass();
            cleverapps.focusManager.display({
                stack: true,
                focus: "LightningRushWindow",
                action: function (f) {
                    new WindowCtor(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });

            cleverapps.tutorial.on("window_shown", (options) => {
                if (options.windowName === `${mission.getName()}_missionwindow`) {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

LightningRushTutorial.createWindowPopAction = function () {
    return new TutorialStep({
        onStart: function () {
            cleverapps.timeouts.setTimeout(() => {
                this.finish();
            }, 200);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

LightningRushTutorial.createGuideStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            const createForce = () => {
                if (this.force) {
                    this.force.close();
                }

                const window = cleverapps.focusManager.currentWindow();
                const view = window.resizable.content;

                this.force = cleverapps.forces.create(view.infoButton, {
                    ...Forces.LIGHTNING_RUSH,
                    gravitate: MinimalDialogue.GRAVITATE.BOTTOM
                }, {
                    importantNodes: [view.titleBg],
                    pointerDirection: PointerView.DIRECTIONS.UP
                });
            };

            createForce();

            window.resizable.onContentChanged = window.createListener(createForce);
            cleverapps.tutorial.on("infoClicked", () => {
                delete window.resizable.onContentChanged;
                this.finish();
            }, this);
            cleverapps.tutorial.on("window_closed", () => {
                delete window.resizable.onContentChanged;
                this.finish();
            }, this);
        },

        onFinish: function () {
            if (this.force) {
                this.force.hideForceHints();
            }
            cleverapps.tutorial.startNextStep();
        }
    });
};

LightningRushTutorial.NAME = "lightning_rush_tutorial";